import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

import { metabolicHealthHeroGradients } from './_data/metabolicHealthHeroGradients';

const MetabolicHealthHero = () => {
  return (
    <section data-cy="metabolic-health-hero">
      <LandingPageHero
        backgroundProps={{
          color: 'mustard-50',
          gradients: metabolicHealthHeroGradients,
        }}
        copy="metabolic_hero_sub_copy"
        eyebrow="metabolic_health"
        images={[
          {
            localizedAlt: 'dexcom_hero_alt_2',
            src: 'scan_food_hero',
          },
          {
            localizedAlt: 'dexcom_hero_alt',
            src: 'dexcom_at_counter',
          },
        ]}
        textColor="text-mustard-700"
        title="metabolic_health_hero_title"
      />
    </section>
  );
};

export default MetabolicHealthHero;
